import React from 'react';
import classNames from 'classnames';

import { ButtonText } from 'src/components/Button';
import ImageC from 'src/components/Image';
import ModalC, { ModalCProps } from 'src/components/Modal';
import { useUnlistFromMarketplace } from 'src/hooks/useInventoryDetail';
import useDeviceSize from 'src/utils/hooks/useDeviceSize';
import { notify } from 'src/utils/notify';

import classes from './index.module.less';

interface ModalCancelListingProps extends ModalCProps {
	data: { name: string; web3_marketplace_id: number; nft_id: string };
	refetchData?: () => Promise<any>;
	onSuccess?: () => void;
}

const ModalCancelListing = ({
	data,
	refetchData,
	onSuccess,
	...props
}: ModalCancelListingProps) => {
	const { onClose } = props;
	const deviceSize = useDeviceSize();

	const { mutate: unlistFromMarketplace, isLoading } = useUnlistFromMarketplace();

	const handleCancelListing = async () => {
		unlistFromMarketplace(
			{ web3_marketplace_id: data.web3_marketplace_id, nft_id: data.nft_id },
			{
				onSuccess: (res: any) => {
					if (res.status === false) {
						notify(res.message ?? 'Failed to cancel listing', 'error');
					} else if (res.status === 200) {
						notify('Success cancel listing');
						onSuccess?.();
						refetchData?.();
						onClose?.(null as any);
					} else {
						notify(
							res?.data?.data?.error ?? res?.data?.message ?? 'Failed to cancel listing',
							'error',
						);
					}
				},
			},
		);
	};

	return (
		<ModalC
			className={classNames('container', classes['modal-cancel-listing'])}
			{...props}
			showCloseIcon={false}
			loading={isLoading}
		>
			<div className={classes.content}>
				<div className={classes.title}>
					<h2>Cancel Listing</h2>
					<ButtonText onClick={onClose} className={classes['btn-modal']}>
						<ImageC
							src="/icons/icon-close-white.svg"
							width={deviceSize === 'desktop' ? 30 : 20}
							height={deviceSize === 'desktop' ? 30 : 20}
						/>
					</ButtonText>
				</div>
				<div className={classes.body}>
					<p>
						Are you sure you want to cancel the listing for <span>{data?.name}</span> ? If yes, you
						will incur a gas fee to cancel it. Do you wish to proceed with the cancellation?
					</p>
					<div className={classes['btn-list']}>
						<ButtonText onClick={onClose} className={classes['btn-outline']}>
							No, keep listing the item
						</ButtonText>
						<ButtonText onClick={handleCancelListing} className={classes['btn-gradient']}>
							Yes, Cancel Listing
						</ButtonText>
					</div>
				</div>
			</div>
		</ModalC>
	);
};

export default ModalCancelListing;
